/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { withTranslation } from 'react-i18next';
import {
  Icon,
  Accordion,
  Modal,
  Loader,
} from 'semantic-ui-react';
import WithRouter from '../Extensions/WithRouter';
import api from '../../api';
import ClarLoader from '../Loader/Loader';
///import { AWS_ACCESS_KEY, AWS_SECRET_ACCESS_KEY } from '../../constants/settings';

class CloudIntegration extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.modalAction = null;
    this.modalSubBody = null;
    this.state = {
      isLoading: false,
      isPageLoading: false,
      isGlobalErrorLoading: false,
      //isLoadingCredential: false,
      //isLoadingBinary: false,
      //isLoadingSbom: false,
      isOpenCredentialModal: false,
      isOpenBinaryModal: false,
      isOpenSbomModal: false,
      isOpenAlertModal: false,
      isModalLoading: false,
      isModalErrorLoading: false,
      isErrorAccessKey: false,
      isErrorBucketSbom: false,
      isErrorBucketBinary: false,
      activeIndex: -1,
      errorMsg: '',
      accessKeyId: '',
      secretAccessKey: '',
      regionWithBinary: '',
      bucketWithBinary: '',
      regionListWithBinary: [],
      regionWithSbom: '',
      bucketWithSbom: '',
      regionListWithSbom: [],
    };
    this.onSubmitWithCredential = this.onSubmitWithCredential.bind(this);
    this.onSubmitWithBinary = this.onSubmitWithBinary.bind(this);
    this.onSubmitWithSbom = this.onSubmitWithSbom.bind(this);
    this.setAwsCredential = this.setAwsCredential.bind(this);
    this.setAwsBinary = this.setAwsBinary.bind(this);
    this.setAwsSbom = this.setAwsSbom.bind(this);
    this.handelRegionChangeWithBinary = this.handelRegionChangeWithBinary.bind(this);
    this.handelRegionChangeWithSbom = this.handelRegionChangeWithSbom.bind(this);
    this.handleAccessKeyChange = this.handleAccessKeyChange.bind(this);
    this.handleSecretAccessKeyChange = this.handleSecretAccessKeyChange.bind(this);
    this.handleCrdAccordion = this.handleCrdAccordion.bind(this);
    this.handleBucketChangeWithSbom = this.handleBucketChangeWithSbom.bind(this);
    this.handleBucketChangeWithBinary = this.handleBucketChangeWithBinary.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.onUpdateLoading();
    //getAwsCredential
    //getAwsBinary
    //getAwsSbom
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;
    const { state } = this.props;
    const {
      awsObj,
    } = state.company;

    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      if (awsObj && awsObj.aws_credential) {
        this.getAwsCredential();
      }

      if (awsObj && awsObj.aws_s3_binary) {
        this.getAwsBinary();
      }

      if (awsObj && awsObj.aws_s3_sbom) {
        this.getAwsSbom();
      }

      if (Object.keys(toJS(awsObj)).length === 0) {
        this.onUpdateFetchData();
      }

      this.setState({
        isPageLoading: false,
      });
    }
  }

  componentWillUnmount() {
  }

  handleAccessKeyChange(event) {
    this.setState({
      accessKeyId: event.target.value,
      isErrorAccessKey: false,
    });
  }

  handleSecretAccessKeyChange(event) {
    this.setState({
      secretAccessKey: event.target.value,
      isErrorSecretKey: false,
    });
  }

  handleBucketChangeWithSbom(event) {
    this.setState({
      bucketWithSbom: event.target.value,
      isErrorBucketSbom: false,
    });
  }

  handleBucketChangeWithBinary(event) {
    this.setState({
      bucketWithBinary: event.target.value,
      isErrorBucketBinary: false,
    });
  }

  handleCrdAccordion(e, titleProps) {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  }

  onSubmitWithCredential() {
    const { t } = this.props;
    if (!this.credentialValidation()) {
      return;
    }

    this.modalAction = t('modal.title.attention');
    this.modalBody = t('system.message.save_aws_credential');

    this.setState({
      isOpenCredentialModal: true,
    });
  }

  onSubmitWithBinary() {
    const { bucketWithBinary } = this.state;
    const { t } = this.props;

    if (bucketWithBinary === '') {
      return this.setState({
        isErrorBucketBinary: true,
      });
    }

    this.modalAction = t('modal.title.attention');
    this.modalBody = t('system.message.save_aws_bucket');

    this.setState({
      isOpenBinaryModal: true,
    });
  }

  onSubmitWithSbom() {
    const { bucketWithSbom } = this.state;
    const { t } = this.props;

    if (bucketWithSbom === '') {
      return this.setState({
        isErrorBucketSbom: true,
      });
    }

    this.modalAction = t('modal.title.attention');
    this.modalBody = t('system.message.save_aws_bucket');

    this.setState({
      isOpenSbomModal: true,
    });
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  onUpdateFetchData() {
    api
      .useUpdatersMenu()
      .then((res) => {
        const awsObj = { ...res.response.cloud_integrations };
        if (awsObj && awsObj.aws_credential) {
          this.getAwsCredential();
        }
        if (awsObj && awsObj.aws_s3_binary) {
          this.getAwsBinary();
        }
        if (awsObj && awsObj.aws_s3_sbom) {
          this.getAwsSbom();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  setAwsCredential() {
    const { t } = this.props;
    const {
      accessKeyId,
      secretAccessKey,
    } = this.state;

    const obj = {
      access_key_id: accessKeyId,
      secret_access_key: secretAccessKey,
    };

    this.setState({
      isModalLoading: true,
    }, () => {
      api
        .setAwsCredential(obj)
        .then((res) => {
          const data = res.response;
          console.log(res);
          this.modalAction = t('modal.title.notice');
          this.modalBody = t('system.message.success_update_aws');
          this.setState({
            accessKeyId: data.access_key_id,
            secretAccessKey: data.secret_access_key,
            isModalLoading: false,
            isModalErrorLoading: true,
          });
        })
        .catch((err) => {
          const o = err.data.response;
          this.modalAction = t('modal.title.attention');

          if (!o.error) {
            this.modalBody = t('modal.error.unknow_error');
            this.modalSubBody = '';
          }

          if (o.error === '422-366') {
            this.modalBody = o.error_description;
            this.modalSubBody = '';
          }

          if (o.error === '422-362') {
            this.modalBody = t('modal.error.error_422_362_access');
            this.modalSubBody = '';
          }

          if (o.error === '422-091') {
            this.modalBody = t('modal.error.error_422_091_param');
            this.modalSubBody = '';
          }

          if (o.error === '422-211') {
            this.modalBody = t('modal.error.error_422_211_value');
            this.modalSubBody = '';
          }

          if (o.error === '422-365') { // license expired
            this.modalBody = t('system.message.license_expired');
            this.modalSubBody = '';
          }

          this.setState({
            isModalLoading: false,
            isModalErrorLoading: true,
          });

          console.log(err);
        });
    });
  }

  setAwsBinary() {
    const { t } = this.props;
    const {
      regionWithBinary,
      bucketWithBinary,
    } = this.state;

    const obj = {
      region: regionWithBinary,
      bucket: bucketWithBinary,
    };

    this.setState({
      isModalLoading: true,
    }, () => {
      api
        .setAwsBinary(obj)
        .then((res) => {
          const data = res.response;
          const currentRegion = data.region.filter((item) => {
            return item.selected && item;
          });
          this.modalAction = t('modal.title.notice');
          this.modalBody = t('system.message.success_update_bucket');
          console.log(res);
          this.setState({
            regionWithBinary: currentRegion[0].region,
            bucketWithBinary: data.bucket,
            regionListWithBinary: data.region,
            isModalLoading: false,
            isModalErrorLoading: true,
          });
        })
        .catch((err) => {
          const o = err.data.response;
          this.modalAction = t('modal.title.attention');

          if (!o.error) {
            this.modalBody = t('modal.error.unknow_error');
            this.modalSubBody = '';
          }

          if (o.error === '422-366') {
            this.modalBody = o.error_description;
            this.modalSubBody = '';
          }

          if (o.error === '422-362') {
            this.modalBody = t('modal.error.error_422_362_access');
            this.modalSubBody = '';
          }

          if (o.error === '422-091') {
            this.modalBody = t('modal.error.error_422_091_param');
            this.modalSubBody = '';
          }

          if (o.error === '422-211') {
            this.modalBody = t('modal.error.error_422_211_value');
            this.modalSubBody = '';
          }

          if (o.error === '422-365') { // license expired
            this.modalBody = t('system.message.license_expired');
            this.modalSubBody = '';
          }

          this.setState({
            isModalLoading: false,
            isModalErrorLoading: true,
          });
          console.log(err);
        });
    });
  }

  setAwsSbom() {
    const {
      regionWithSbom,
      bucketWithSbom,
    } = this.state;
    const { t } = this.props;

    const obj = {
      region: regionWithSbom,
      bucket: bucketWithSbom,
    };

    this.setState({
      isModalLoading: true,
    }, () => {
      api
        .setAwsSbom(obj)
        .then((res) => {
          const data = res.response;
          const currentRegion = data.region.filter((item) => {
            return item.selected && item;
          });
          this.modalAction = t('modal.title.notice');
          this.modalBody = t('system.message.success_update_bucket');
          this.setState({
            regionWithSbom: currentRegion[0].region,
            bucketWithSbom: data.bucket,
            regionListWithSbom: data.region,
            isModalLoading: false,
            isModalErrorLoading: true,
          });
        })
        .catch((err) => {
          const o = err.data.response;
          this.modalAction = t('modal.title.attention');

          if (!o.error) {
            this.modalBody = t('modal.error.unknow_error');
            this.modalSubBody = '';
          }

          if (o.error === '422-366') {
            this.modalBody = o.error_description;
            this.modalSubBody = '';
          }

          if (o.error === '422-362') {
            this.modalBody = t('modal.error.error_422_362_access');
            this.modalSubBody = '';
          }

          if (o.error === '422-091') {
            this.modalBody = t('modal.error.error_422_091_param');
            this.modalSubBody = '';
          }

          if (o.error === '422-211') {
            this.modalBody = t('modal.error.error_422_211_value');
            this.modalSubBody = '';
          }

          if (o.error === '422-365') { // license expired
            this.modalBody = t('system.message.license_expired');
            this.modalSubBody = '';
          }

          this.setState({
            isModalLoading: false,
            isModalErrorLoading: true,
          });
          console.log(err);
        });
    });
  }

  getAwsCredential() {
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getAwsCredential()
        .then((res) => {
          const data = res.response;
          this.setState({
            accessKeyId: data.access_key_id,
            secretAccessKey: data.secret_access_key,
            isLoading: false,
            isGlobalErrorLoading: false,
            errorMsg: '',
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          const text = o.error_description || null;

          this.setState({
            isLoading: false,
            isGlobalErrorLoading: true,
            errorMsg: text,
          });
        });
    });
  }

  getAwsBinary() {
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getAwsBinary()
        .then((res) => {
          const data = res.response;
          const currentRegion = data.region.filter((item) => {
            return item.selected && item;
          });
          this.setState({
            regionWithBinary: currentRegion[0].region,
            bucketWithBinary: data.bucket,
            regionListWithBinary: data.region,
            isLoading: false,
            isGlobalErrorLoading: false,
            errorMsg: '',
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          const text = o.error_description || null;

          this.setState({
            isLoading: false,
            isGlobalErrorLoading: true,
            errorMsg: text,
          });
        });
    });
  }

  getAwsSbom() {
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getAwsSbom()
        .then((res) => {
          const data = res.response;
          const currentRegion = data.region.filter((item) => {
            return item.selected && item;
          });
          this.setState({
            regionWithSbom: currentRegion[0].region,
            bucketWithSbom: data.bucket,
            regionListWithSbom: data.region,
            isLoading: false,
            isGlobalErrorLoading: false,
            errorMsg: '',
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          const text = o.error_description || null;

          this.setState({
            isLoading: false,
            isGlobalErrorLoading: true,
            errorMsg: text,
          });
        });
    });
  }

  handelRegionChangeWithSbom(e) {
    const { regionWithSbom } = this.state;

    if (e.target.value === regionWithSbom) {
      return;
    }

    this.setState({
      regionWithSbom: e.target.value,
    });
  }

  handelRegionChangeWithBinary(e) {
    const { regionWithBinary } = this.state;

    if (e.target.value === regionWithBinary) {
      return;
    }

    this.setState({
      regionWithBinary: e.target.value,
    });
  }

  credentialValidation() {
    const { t } = this.props;
    const {
      accessKeyId,
      secretAccessKey,
    } = this.state;

    if (accessKeyId === '') {
      this.modalAction = t('modal.title.attention');
      this.modalBody = t('modal.error.access_key_required');
      this.setState({
        isErrorAccessKey: true,
        isErrorSecretKey: false,
        isOpenAlertModal: true,
      });
      return false;
    }

    if (secretAccessKey === '') {
      this.modalAction = t('modal.title.attention');
      this.modalBody = t('modal.error.secret_access_key_required');
      this.setState({
        isErrorAccessKey: false,
        isErrorSecretKey: true,
        isOpenAlertModal: true,
      });
      return false;
    }
    return true;
  }

  closeModal() {
    this.setState({
      isOpenCredentialModal: false,
      isOpenBinaryModal: false,
      isOpenSbomModal: false,
      isOpenAlertModal: false,
      isModalErrorLoading: false,
    });
  }

  render() {
    const { t } = this.props;
    const {
      isOpenCredentialModal,
      isOpenBinaryModal,
      isOpenSbomModal,
      isOpenAlertModal,
      isModalLoading,
      isModalErrorLoading,
      isGlobalErrorLoading,
      isErrorAccessKey,
      isErrorSecretKey,
      isErrorBucketSbom,
      isErrorBucketBinary,
      isLoading,
      errorMsg,
      //isLoadingCredential,
      //isLoadingBinary,
      //isLoadingSbom,
      activeIndex,
      accessKeyId,
      secretAccessKey,
      regionWithBinary,
      bucketWithBinary,
      regionListWithBinary,
      regionWithSbom,
      bucketWithSbom,
      regionListWithSbom,
    } = this.state;

    const {
      awsObj,
    } = this.props.state.company;

    const renderIfReady = (element) => {
      return !isLoading ? (
        element
      ) : (
        <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
          {t('modal.message.loading')}
        </Loader>
      );
    };

    return (
      <div>
        <div className="content">
          <div className="setting_small_box setting_small_box_2">
            <h2 className="page_title">
              AWS
              {isGlobalErrorLoading ? <span className="error">{errorMsg}</span> : null}
              <Accordion
                styled
                style={{
                  fontSize: '13px', marginTop: '25px', marginBottom: '3px', with: '50%'
                }}
              >
                <Accordion.Title
                  active={activeIndex === 0}
                  index={0}
                  onClick={this.handleCrdAccordion}
                  style={{ padding: '3px 4px ' }}
                >
                  <Icon name="dropdown" />
                  <Icon name="info circle" />
                  {t('system.title.generate_aws')}
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 0}>
                  <p>{t('system.message.aws_login')}</p>
                  <p>{t('system.message.aws_dashboard')}</p>
                  <p>{t('system.message.aws_user')}</p>
                  <p>{t('system.message.aws_add_user')}</p>
                  <p>{t('system.message.aws_add_user_name')}</p>
                  <p>{t('system.message.aws_access_type')}</p>
                  <p>{t('system.message.aws_next')}</p>
                  <p>{t('system.message.aws_select')}</p>
                  <p>{t('system.message.aws_search')}</p>
                  <p>{t('system.message.aws_policy')}</p>
                  <p>{t('system.message.aws_creat_user')}</p>
                  <p>{t('system.message.aws_credential')}</p>
                </Accordion.Content>
              </Accordion>
            </h2>
            {
              renderIfReady(
                <div>
                  <div className="setting_contnets">
                    {
                      awsObj && awsObj.aws_credential && (
                        <div>
                          <div className="setting_contnet_wrap">
                            <div className="custom_content">
                              <h3 className="setting_content_title">{t('system.title.credentials')}</h3>
                            </div>
                          </div>
                          <div className="setting_contnet_wrap" style={{ paddingLeft: '30px', marginTop: '25px' }}>
                            <div className="custom_content">
                              <h3 className="setting_content_title">
                                {t('system.title.access_key')}
                              </h3>
                              <div className="setting_content">
                                <input
                                  type="text"
                                  style={{ width: '50%' }}
                                  value={accessKeyId}
                                  onChange={this.handleAccessKeyChange}
                                  autoComplete="new-password"
                                //placeholder={`${t('system.list.example')} 127.0.0.1`}
                                />
                                {
                                  isErrorAccessKey
                                && (
                                  <div
                                    className="error show"
                                  >
                                    {t('system.message.access_key_error')}
                                  </div>
                                )
                                }
                              </div>
                            </div>
                          </div>
                          <div className="setting_contnet_wrap" style={{ paddingLeft: '30px', marginTop: '25px' }}>
                            <div className="custom_content">
                              <h3 className="setting_content_title">
                                {t('system.title.secret_access_key')}
                              </h3>
                              <div className="setting_content">
                                <input
                                  type="text"
                                  style={{ width: '50%' }}
                                  value={secretAccessKey}
                                  onChange={this.handleSecretAccessKeyChange}
                                  autoComplete="new-password"
                                //placeholder={`${t('system.list.example')} 127.0.0.1`}
                                />
                                {
                                  isErrorSecretKey
                                && (
                                  <div
                                    className="error show"
                                  >
                                    {t('system.message.secret_access_key_error')}
                                  </div>
                                )
                                }
                              </div>
                            </div>
                          </div>
                          <div className="setting_contnet_wrap" style={{ marginTop: '0' }}>
                            <div className="setting_content">
                              <div className="right_box">
                                <a
                                  className="update"
                                  onClick={this.onSubmitWithCredential}
                                  onKeyUp={this.onSubmitWithCredential}
                                >
                                  {t('modal.button.save')}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    }
                    {
                      awsObj && awsObj.aws_credential && (awsObj.aws_s3_binary || awsObj.aws_s3_sbom)
                    && <div className="line" />
                    }
                    {
                      awsObj && awsObj.aws_s3_binary && (
                        <div style={{ marginTop: '30px' }}>
                          <div className="setting_contnet_wrap">
                            <div className="custom_content">
                              <h3 className="setting_content_title">
                                {t('system.title.bucket_to_upload_binary')}
                                <Accordion
                                  styled
                                  style={{
                                    fontSize: '13px', lineHeight: '31px', marginLeft: '1px', marginTop: '25px', marginBottom: '3px', with: '50%'
                                  }}
                                >
                                  <Accordion.Title
                                    active={activeIndex === 1}
                                    index={1}
                                    onClick={this.handleCrdAccordion}
                                    style={{ padding: '3px 4px ' }}
                                  >
                                    <Icon name="dropdown" />
                                    <Icon name="info circle" />
                                    {t('system.title.create_bucket')}
                                  </Accordion.Title>
                                  <Accordion.Content active={activeIndex === 1}>
                                    <p>{t('system.message.bucket_upload')}</p>
                                    <p />
                                    <p>{t('system.message.bucket_login_aws')}</p>
                                    <p>{t('system.message.bucket_s3_dashboard')}</p>
                                    <p>{t('system.message.bucket_create')}</p>
                                    <p>{t('system.message.bucket_name')}</p>
                                    <p>{t('system.message.bucket_region')}</p>
                                  </Accordion.Content>
                                </Accordion>
                              </h3>
                            </div>
                          </div>
                          <div className="setting_contnet_wrap" style={{ paddingLeft: '30px', marginTop: '25px' }}>
                            <div className="custom_content">
                              <h3 className="setting_content_title">
                                {t('system.title.region')}
                              </h3>
                              <div className="setting_content">
                                <select
                                  onChange={this.handelRegionChangeWithBinary}
                                  value={regionWithBinary}
                                >
                                  {
                                    regionListWithBinary.map((item) => {
                                      return (
                                        <option value={item.region} key={item.region.toString()}>{item.text}</option>
                                      );
                                    })
                                  }
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="setting_contnet_wrap" style={{ paddingLeft: '30px', marginTop: '25px' }}>
                            <div className="custom_content">
                              <h3 className="setting_content_title">
                                {t('system.title.bucket')}
                              </h3>
                              <div className="setting_content">
                                <input
                                  type="text"
                                  style={{ width: '50%' }}
                                  value={bucketWithBinary}
                                  onChange={this.handleBucketChangeWithBinary}
                                />
                                {
                                  isErrorBucketBinary
                                && (
                                  <div
                                    className="error show"
                                  >
                                    {t('system.message.s3_bucket')}
                                  </div>
                                )
                                }
                              </div>
                            </div>
                          </div>
                          <div className="setting_contnet_wrap" style={{ marginTop: '0' }}>
                            <div className="setting_content">
                              <div className="right_box">
                                <a
                                  className="update"
                                  onClick={this.onSubmitWithBinary}
                                  onKeyUp={this.onSubmitWithBinary}
                                >
                                  {t('modal.button.save')}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    }
                    {
                      awsObj && awsObj.aws_s3_binary && awsObj.aws_s3_sbom
                    && <div className="line" />
                    }
                    {
                      awsObj && awsObj.aws_s3_sbom && (
                        <div style={{ marginTop: '30px' }}>
                          <div className="setting_contnet_wrap">
                            <div className="custom_content">
                              <h3 className="setting_content_title">
                                {t('system.title.bucket_to_upload_sbom')}
                                <Accordion
                                  styled
                                  style={{
                                    fontSize: '13px', lineHeight: '31px', marginLeft: '1px', marginTop: '25px', marginBottom: '3px', with: '50%'
                                  }}
                                >
                                  <Accordion.Title
                                    active={activeIndex === 2}
                                    index={2}
                                    onClick={this.handleCrdAccordion}
                                    style={{ padding: '3px 4px ' }}
                                  >
                                    <Icon name="dropdown" />
                                    <Icon name="info circle" />
                                    {t('system.title.create_bucket')}
                                  </Accordion.Title>
                                  <Accordion.Content active={activeIndex === 2}>
                                    <p>{t('system.message.bucket_upload')}</p>
                                    <p />
                                    <p>{t('system.message.bucket_login_aws')}</p>
                                    <p>{t('system.message.bucket_s3_dashboard')}</p>
                                    <p>{t('system.message.bucket_create')}</p>
                                    <p>{t('system.message.bucket_name')}</p>
                                    <p>{t('system.message.bucket_region')}</p>
                                  </Accordion.Content>
                                </Accordion>
                              </h3>
                            </div>
                          </div>
                          <div className="setting_contnet_wrap" style={{ paddingLeft: '30px', marginTop: '25px' }}>
                            <div className="custom_content">
                              <h3 className="setting_content_title">
                                {t('system.title.region')}
                              </h3>
                              <div className="setting_content">
                                <select
                                  onChange={this.handelRegionChangeWithSbom}
                                  value={regionWithSbom}
                                >
                                  {
                                    regionListWithSbom.map((item) => {
                                      return (
                                        <option value={item.region} key={item.region.toString()}>{item.text}</option>
                                      );
                                    })
                                  }
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="setting_contnet_wrap" style={{ paddingLeft: '30px', marginTop: '25px' }}>
                            <div className="custom_content">
                              <h3 className="setting_content_title">
                                {t('system.title.bucket')}
                              </h3>
                              <div className="setting_content">
                                <input
                                  type="text"
                                  style={{ width: '50%' }}
                                  value={bucketWithSbom}
                                  onChange={this.handleBucketChangeWithSbom}
                                />
                                {
                                  isErrorBucketSbom
                                && (
                                  <div
                                    className="error show"
                                  >
                                    {t('system.message.s3_bucket')}
                                  </div>
                                )
                                }
                              </div>
                            </div>
                          </div>
                          <div className="setting_contnet_wrap" style={{ marginTop: '0' }}>
                            <div className="setting_content">
                              <div className="right_box">
                                <a
                                  className="update"
                                  onClick={this.onSubmitWithSbom}
                                  onKeyUp={this.onSubmitWithSbom}
                                >
                                  {t('modal.button.save')}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    }
                  </div>
                </div>
              )
            }
          </div>
        </div>
        <Modal
          open={isOpenCredentialModal}
          //onClose={this.closeModal}
        >
          {
            isModalLoading ? <ClarLoader />
              : (
                <div className="modal_popup_wrap confirm_wrap">
                  <div className="modal_popup_box confirm_box">
                    <div className="modal_popup confirm">
                      <h2 className="title">{this.modalAction}</h2>
                      <p className="text">{this.modalBody}</p>
                      {
                        isModalErrorLoading
                        && (
                          <p className="small_text">
                            {this.modalSubBody}
                          </p>
                        )
                      }
                      {
                        isModalErrorLoading ? (
                          <div className="button_wrap">
                            <a
                              className="center_button"
                              onClick={this.closeModal}
                              onKeyUp={this.closeModal}
                            >
                              {t('modal.button.ok')}
                            </a>
                          </div>
                        ) : (
                          <div className="button_wrap">
                            <a
                              className="left_button"
                              onClick={this.closeModal}
                              onKeyUp={this.closeModal}
                            >
                              {t('modal.button.no')}
                            </a>
                            <a
                              className="right_button"
                              onClick={this.setAwsCredential}
                              onKeyUp={this.setAwsCredential}
                            >
                              {t('modal.button.yes')}
                            </a>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              )
          }
        </Modal>
        <Modal
          open={isOpenBinaryModal}
          //onClose={this.closeModal}
        >
          {
            isModalLoading ? <ClarLoader />
              : (
                <div className="modal_popup_wrap confirm_wrap">
                  <div className="modal_popup_box confirm_box">
                    <div className="modal_popup confirm">
                      <h2 className="title">{this.modalAction}</h2>
                      <p className="text">{this.modalBody}</p>
                      {
                        isModalErrorLoading
                        && (
                          <p className="small_text">
                            {this.modalSubBody}
                          </p>
                        )
                      }
                      {
                        isModalErrorLoading ? (
                          <div className="button_wrap">
                            <a
                              className="center_button"
                              onClick={this.closeModal}
                              onKeyUp={this.closeModal}
                            >
                              {t('modal.button.ok')}
                            </a>
                          </div>
                        ) : (
                          <div className="button_wrap">
                            <a
                              className="left_button"
                              onClick={this.closeModal}
                              onKeyUp={this.closeModal}
                            >
                              {t('modal.button.no')}
                            </a>
                            <a
                              className="right_button"
                              onClick={this.setAwsBinary}
                              onKeyUp={this.setAwsBinary}
                            >
                              {t('modal.button.yes')}
                            </a>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              )
          }
        </Modal>
        <Modal
          open={isOpenSbomModal}
          //onClose={this.closeModal}
        >
          {
            isModalLoading ? <ClarLoader />
              : (
                <div className="modal_popup_wrap confirm_wrap">
                  <div className="modal_popup_box confirm_box">
                    <div className="modal_popup confirm">
                      <h2 className="title">{this.modalAction}</h2>
                      <p className="text">{this.modalBody}</p>
                      {
                        isModalErrorLoading
                        && (
                          <p className="small_text">
                            {this.modalSubBody}
                          </p>
                        )
                      }
                      {
                        isModalErrorLoading ? (
                          <div className="button_wrap">
                            <a
                              className="center_button"
                              onClick={this.closeModal}
                              onKeyUp={this.closeModal}
                            >
                              {t('modal.button.ok')}
                            </a>
                          </div>
                        ) : (
                          <div className="button_wrap">
                            <a
                              className="left_button"
                              onClick={this.closeModal}
                              onKeyUp={this.closeModal}
                            >
                              {t('modal.button.no')}
                            </a>
                            <a
                              className="right_button"
                              onClick={this.setAwsSbom}
                              onKeyUp={this.setAwsSbom}
                            >
                              {t('modal.button.yes')}
                            </a>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              )
          }
        </Modal>
        <Modal open={isOpenAlertModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter((withTranslation()(inject('state')(observer(CloudIntegration)))));
